import classNames from 'classnames'
import { useContext, useEffect, useRef, useState } from 'react'
import { FooterModal } from './FooterModal'
import { FilterOptionsTitle } from './FilterOptionsTitle'
import { PrimaryButton } from './PrimaryButton'
import { optionTypes } from '../constants/all'
import {
  EmptyFunction,
  optionHandler,
  fetchOptions,
  removeReference,
  isOptionPresent,
  seekersAnalayticOptions,
  getAsPath,
  getMethod
} from '../utils/functions'
import { FilterOption } from './FilterOption'
import { CircularSpinner } from './CircularSpinner'
import { OfflineIndicator } from './OfflineIndicator'
import ImageWithBasePath from './ImageWithBasePath'
import { trackEvent } from '../analytics'
import { NextLink } from '../commonComponents/NextLink'
import { Pagination } from './Pagination'
import { GET_lOCATION_LIST } from '../constants/all'
import { SharedContext } from '../context/SharedContext'
import { SeekerContext } from '../context/SeekerContext'

const FilterTitlesContainer = ({
  filters,
  filterTitleHandler,
  selectedTitleId,
  selectedOptions,
  options = []
}) => {
  const sortedFilters = [...filters].sort((option1, option2) =>
    option1.english_name.localeCompare(option2.english_name)
  )
  const isOptionPresent = (id) => {
    let count = 0
    selectedOptions?.[id]?.forEach((item) => {
      const optionValue = options?.[id]?.find((i) => i.id == item.id)
      if (optionValue) count++
    })
    return count
  }

  return (
    <div
      id="filter_titles_container"
      className="scrollbarHidden flex h-[440px] w-[131px] flex-col overflow-y-scroll bg-white"
    >
      {sortedFilters.map((item, index) => (
        <div id="filter_title" key={index}>
          <FilterOptionsTitle
            {...{
              title: item?.english_name || '',
              onClick: () => filterTitleHandler({ item }),
              isSelected: item.id === selectedTitleId,
              selectedCount: isOptionPresent(item.id)
            }}
          />
        </div>
      ))}
    </div>
  )
}

const EmptyOptionsHandler = ({ titleComponent, content, contentClassName }) => {
  return (
    <div
      id="filter_empty_container"
      className="flex h-full w-full flex-col items-center justify-center space-y-[12px]"
    >
      {titleComponent()}
      <div
        id="filter_empty_content"
        className={classNames(
          'text-center font-noto-sans text-base font-medium leading-[21.11px] text-[#404040] text-opacity-80',
          contentClassName
        )}
      >
        {content}
      </div>
    </div>
  )
}

const OptionsContainer = ({
  options = [],
  selectedOptions,
  setSelectedOptions,
  selectedTitleId,
  optionHandler,
  loader,
  filterIdsWithNames,
  pagination,
  setPagination,
  setOptions
}) => {
  const listRef = useRef()
  const [count, setCount] = useState(10)

  const handleScroll = () => {
    const list = listRef.current

    if (list) {
      if (list.scrollTop + list.clientHeight === list.scrollHeight) {
        getAllCitiesList()
      }
    }
  }

  async function getAllCitiesList() {
    if (count >= options?.length) {
      const params = { page: pagination.pageNumber + 1, type: 'all' }
      //setCurrent((prv) => ({...prv, response: false}))
      const response = await getMethod({
        url: `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${GET_lOCATION_LIST}`,
        params
      })
      if (response?.results?.length > 0) {
        setCount(response?.count)
        setOptions((prv) => {
          let results = { ...prv }
          if (prv?.[2]?.length) {
            results[2] = [
              ...prv[2],
              ...response?.results?.map((item) => ({
                id: item.id,
                english_name: item.title,
                title: item.title_trans
              }))
            ]
          } else {
            results[2] = [
              ...response?.results?.map((item) => ({
                id: item.id,
                english_name: item.title,
                title: item.title_trans
              }))
            ]
          }
          return results
        })
      } else {
        setPagination((prv) => ({ ...prv, hasMore: false }))
      }
      setPagination((prv) => ({ ...prv, pageNumber: prv.pageNumber + 1 }))
    }
  }
  let buttonType = 'checkBox'
  if (optionTypes?.radio.includes(filterIdsWithNames[selectedTitleId])) buttonType = 'radio'
  return (
    <div id="filter_options_container" className=" h-[440px] flex-1  pb-md pl-16 pr-19">
      {!loader && options?.length <= 0 && (
        <div className="flex h-full px-[20px]">
          <EmptyOptionsHandler
            titleComponent={() => (
              <ImageWithBasePath src="carbon_filter" height={39} width={39} alt="carbon filter" />
            )}
            content={`${optionTypes?.[buttonType]?.[selectedTitleId]} filter not available. Please select other filters`}
          />
        </div>
      )}
      {!loader &&
        (selectedTitleId == 2 ? (
          <Pagination
            listLength={options?.length}
            next={getAllCitiesList()}
            hasMore={pagination.hasMore}
            loader={<CircularSpinner />}
            className="overflow-hidden"
          >
            <div
              ref={listRef}
              className="scrollbarHidden"
              style={{ overflowY: 'auto', maxHeight: '420px' }}
              onScroll={handleScroll}
            >
              {options?.map((item, index) => (
                <div id="filter_option" key={index}>
                  <FilterOption
                    {...{
                      title: item.title,
                      isClicked: isOptionPresent({
                        list: selectedOptions?.[selectedTitleId],
                        searchValue: item?.id,
                        key: 'id'
                      }),
                      buttonType,
                      responseFunction: () =>
                        optionHandler({
                          optionData: item,
                          setSelectedOptions,
                          selectedTitleId,
                          buttonType
                        })
                    }}
                  />
                </div>
              ))}
            </div>
          </Pagination>
        ) : (
          <div
            ref={listRef}
            className="scrollbarHidden"
            style={{ overflowY: 'auto', maxHeight: '420px' }}
            onScroll={handleScroll}
          >
            {options?.map((item, index) => (
              <div id="filter_option" key={index}>
                <FilterOption
                  {...{
                    title: item.title,
                    isClicked: isOptionPresent({
                      list: selectedOptions?.[selectedTitleId],
                      searchValue: item?.id,
                      key: 'id'
                    }),
                    buttonType,
                    responseFunction: () =>
                      optionHandler({
                        optionData: item,
                        setSelectedOptions,
                        selectedTitleId,
                        buttonType
                      })
                  }}
                />
              </div>
            ))}
          </div>
        ))}
      {loader && (
        <EmptyOptionsHandler
          titleComponent={() => <CircularSpinner />}
          content="Loading filters..."
        />
      )}
    </div>
  )
}
export const ListingFilter = ({
  isOpen = false,
  handleModalClose,
  filterTitles = {},
  applyHandler = EmptyFunction,
  selectedId,
  initialSelectedOptions = {}
}) => {
  const [options, setOptions] = useState({})
  const [selectedTitleId, setSelectedTitleId] = useState(selectedId || filterTitles?.[0]?.id)
  const [loader, setLoader] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState({})
  const [totalSelectedFilters, setTotalSelectedFilters] = useState('')
  const {
    isOnline,
    language,
    utmParams,
    loginDetails,
    location
  } = useContext(SharedContext);
  
  const {
    filterTitleIds,
    setFilterNameWFH
  } = useContext(SeekerContext);
  const filterIdsWithNames = useRef({})
  const [pagination, setPagination] = useState({ pageNumber: 1, hasMore: true })

  const filterTitleHandler = ({ item }) => {
    setSelectedTitleId(item?.id)
  }

  const clearHandler = () => {
    setSelectedOptions({})
    setFilterNameWFH('')
  }

  const beforeApplyHandler = () => {
    applyHandler(selectedOptions)

    const selectedFilters = filterTitles
      ?.filter((item) => Object?.keys(selectedOptions)?.includes(String?.(item?.id)))
      ?.map((item) => item?.english_name)

    trackEvent({
      name: 'filters_applied',
      searchParams: {
        ...utmParams
      },
      options: {
        ...seekersAnalayticOptions(window, loginDetails, location, 'tap', 'seeker_listings_page'),
        'type of filters applied': selectedFilters?.join('/')
      },
      isSeeker: true
    })
    handleModalClose()
  }

  useEffect(() => {
    setSelectedTitleId(selectedId)
  }, [selectedId])

  useEffect(() => {
    if (isOpen) {
      const result = {}
      filterTitles?.forEach((element) => {
        result[element?.id || ''] = element?.english_name
      })
      filterIdsWithNames.current = { ...result }
      setSelectedOptions(removeReference(initialSelectedOptions))
    }
  }, [isOpen])

  useEffect(() => {
    fetchOptions({
      selectedTitleId,
      setOptions,
      options,
      setLoader,
      language,
      pagination,
      setPagination
    })
  }, [selectedTitleId])

  useEffect(() => {
    const res = Object.keys(selectedOptions).filter((item) => selectedOptions?.[item]?.length > 0)
    setTotalSelectedFilters(res.length > 0 ? `(${res.length})` : '')
  }, [selectedOptions])

  return (
    <FooterModal
      {...{
        isOpen,
        handleModalClose,
        title: classNames('Filters', totalSelectedFilters),
        headerClassName: 'shadow-base',
        className: 'h-[554px]'
      }}
    >
      <div
        id="filter_container"
        className="flex h-full flex-col bg-[#404040] bg-opacity-5 font-noto-sans"
      >
        {!isOnline && (
          <OfflineIndicator
            onClick={() =>
              fetchOptions({
                selectedTitleId,
                setOptions,
                options,
                setLoader,
                language,
                pagination,
                setPagination
              })
            }
          />
        )}
        {isOnline && (
          <>
            <div className="flex">
              <FilterTitlesContainer
                {...{
                  filters: filterTitles || [],
                  filterTitleHandler,
                  selectedTitleId,
                  selectedOptions,
                  options
                }}
              />
              <OptionsContainer
                {...{
                  options: options?.[selectedTitleId] || [],
                  selectedOptions,
                  optionHandler,
                  selectedTitleId,
                  loader,
                  setSelectedOptions,
                  filterIdsWithNames: filterIdsWithNames?.current,
                  pagination,
                  setOptions,
                  setLoader,
                  language,
                  setPagination
                }}
              />
            </div>
            <div
              id="filter_footer_buttons"
              className="z-40 flex w-full space-x-[8px] bg-white p-sm shadow-primaryButton"
            >
              <div className="flex-1">
                <PrimaryButton
                  id="filter_clear_all"
                  title={'Clear All'}
                  className=" rounded-[3px] border-[#FFBB00] bg-[#FFFFFF] text-base leading-16 text-[#333436] active:bg-secondary active:bg-opacity-20"
                  onClick={clearHandler}
                />
              </div>
              <div className={'flex-1 '}>
                <NextLink
                  id={'filteres_apply_button'}
                  href={'jobsFiltering'}
                  isLoader={false}
                  shallow={true}
                  replace={true}
                  as={`jobs/${getAsPath({ selectedOptions, filterTitleIds })}`}
                  onClick={beforeApplyHandler}
                >
                  <PrimaryButton
                    id="filter_apply"
                    title={'Apply'}
                    className=" rounded-[4px] border-secondary bg-secondary text-base leading-16 text-[#333436] sm:h-[44px]"
                  />
                </NextLink>
              </div>
            </div>
          </>
        )}
      </div>
    </FooterModal>
  )
}
